import React, { useRef, useEffect, useState } from 'react';
import './Games.css'; // Importa o CSS específico para os jogos

// Adicione imagens dos jogos na pasta /assets e importe-as
import starLegionImg from '../assets/games/starLegion.png'
import stompStompImg from '../assets/games/stompStomp.png'
import survivorKnightImg from '../assets/games/survivorKnight.png'
import breakpointZeroImg from '../assets/games/breakpointZero.png'
import tinySmithImg from '../assets/games/tinySmith.png'
import comingSoonOverlay from '../assets/coming-soon.png';

// Defina os dados dos jogos em um array
const gamesData = [
  {
    title: 'Star Legion',
    description: 'Lidere combates intensos em planetas distantes como um super soldado do Império! Enfrente inimigos alienígenas, complete missões estratégicas e ajude a expandir o domínio humano pela galáxia.',
    image: starLegionImg,
    storeLink: 'https://store.steampowered.com/app/3657030/Star_Legion',
    released: true,
  },
  {
    title: 'Stomp Stomp',
    description: 'Controle um monstro gigante em ritmo acelerado e destrua tudo pelo caminho! Esmague prédios, desvie de obstáculos e sincronize seus passos com a batida para causar o caos perfeito na cidade.',
    image: stompStompImg,
    storeLink: 'https://play.google.com/store/apps/details?id=com.HelloWorldGames.StompStomp&pcampaignid=web_share',
    released: true,
  },
  {
    title: 'Survivor Knight',
    description: 'Enfrente hordas de monstros em batalhas cheias de ação com cavaleiros lendários! Escolha seu herói, desbloqueie habilidades e sobreviva o máximo que puder nesse combate intenso e cheio de perigos.',
    image: survivorKnightImg,
    storeLink: 'https://play.google.com/store/apps/details?id=com.HelloWorldGamesStudio.SurvivorKnight&pcampaignid=web_share',
    released: true,
  },
  {
    title: 'Breakpoint Zero',
    description: 'Invada territórios hostis, lute por recursos raros e extraia antes que os inimigos te encontrem. Customize seu equipamento, assuma riscos calculados e tente sair vivo nesse shooter tático implacável.',
    image: breakpointZeroImg,
    storeLink: '#',
    released: false,
  },
  {
    title: 'Tiny Smith',
    description: 'Gerencie sua própria forja em um vilarejo encantador! Colete recursos, crie armas e equipamentos sob encomenda e atenda heróis em busca das melhores ferramentas para suas aventuras.',
    image: tinySmithImg,
    storeLink: '#',
    released: false,
  },
];


function Games() {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [cardsPerGroup, setCardsPerGroup] = useState(3);

  const itemsPerView = () => {
    const width = window.innerWidth;
    if (width < 600) return 1;
    if (width < 992) return 2;
    return 3;
  };

  const scrollToIndex = (index) => {
    const container = carouselRef.current;
    const cardWidth = container.firstChild.offsetWidth + 20;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    const targetScroll = Math.min(
      Math.max(0, cardWidth * cardsPerGroup * index),
      maxScrollLeft
    );

    container.scrollTo({ left: targetScroll, behavior: 'smooth' });
    setActiveIndex(index);
  };

  const scrollByCard = (direction) => {
    const totalGroups = Math.ceil(gamesData.length / cardsPerGroup);
    let nextIndex = activeIndex + direction;
    if (nextIndex < 0) nextIndex = totalGroups - 1;
    if (nextIndex >= totalGroups) nextIndex = 0;
    scrollToIndex(nextIndex);
  };

  useEffect(() => {
  const updateCardsPerGroup = () => {
    const width = window.innerWidth;
    if (width < 600) setCardsPerGroup(1);
    else if (width < 992) setCardsPerGroup(2);
    else setCardsPerGroup(3);
  };

  updateCardsPerGroup();
  window.addEventListener('resize', updateCardsPerGroup);
  return () => window.removeEventListener('resize', updateCardsPerGroup);
}, []);

  // Autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      scrollByCard(1);
    }, 7000); // 7s

    return () => clearInterval(interval);
  });

  const totalIndicators = Math.ceil(gamesData.length / cardsPerGroup);

  return (
    <section id="games" className="games-section">
      <h2>Nossos Jogos</h2>
      <div className="carousel-wrapper">
        <button className="carousel-button left" onClick={() => scrollByCard(-1)}>&#10094;</button>

        <div className="games-carousel" ref={carouselRef}>
          {gamesData.map((game, index) => (
            <a
              href={game.storeLink}
              key={index}
              className="game-card carousel-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="image-wrapper">
                <img src={game.image} alt={game.title} className="game-image" />
                {!game.released && (
                  <img src={comingSoonOverlay} alt="Em breve" className="overlay-image" />
                )}
              </div>
              <h3>{game.title}</h3>
              <p>{game.description}</p>
            </a>
          ))}
        </div>

        <button className="carousel-button right" onClick={() => scrollByCard(1)}>&#10095;</button>
      </div>

      <div className="carousel-indicators">
        {Array.from({ length: totalIndicators }).map((_, index) => (
          <span
            key={index}
            className={`indicator-dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => scrollToIndex(index)}
          ></span>
        ))}
      </div>
    </section>
  );
}

export default Games;
